import { render, staticRenderFns } from "./ItemVariationName.vue?vue&type=template&id=57a671af&"
import script from "./ItemVariationName.vue?vue&type=script&lang=js&"
export * from "./ItemVariationName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports